"use client";
import { useRouter, usePathname } from "next/navigation";

interface Props {
  locale: string;
}

export const BatchSwitch = ({ locale }: Props) => {
  const router = useRouter();
  const pathname = usePathname();
  return (
    <>
      <div className="flex border-b border-[#ebedf0] mb-[25px]">
        <div
          className={`tab-item ${pathname.includes("douyin") ? "active" : ""}`}
          onClick={() => router.push(`/${locale}/douyin`)}
        >
          链接提取
        </div>
        <div
          className={`tab-item ${pathname.includes("dy-page") ? "active" : ""}`}
          onClick={() => router.push(`/${locale}/dy-page`)}
        >
          主页提取
        </div>
        <div
          className={`tab-item ${pathname.includes("dy-search") ? "active" : ""}`}
          onClick={() => router.push(`/${locale}/dy-search`)}
        >
          搜索下载
        </div>
      </div>
    </>
  );
};
